// extracted by mini-css-extract-plugin
export default {"container":"InfoContent_container__LO0iQ"};